export class FormOptions {
    dataGetterEnabled: boolean;
    apiEndPoint: string;
    params: string[];

    inlineForm: boolean;
    mode: FormMode
}

export enum FormMode {
    Create,
    Modify
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/data-models/form-options.ts